import vv_utils from './vv_utils';
import {simpleInvokeMachine, fullInvokeMachine } from "./vv_api";

function setupMfaEmail(emailConfig) {
///////////////////////////////////////

/*  
  const emailConfig = {
    pageAlertbox: document.getElementById("add-totp-email-alert"),
    formAlertbox: document.getElementById("add-totp-email-alert"),
    verifyTitle: document.getElementById('verifyTitle'),
    cancelBtn: null,
    verifyBtn: document.getElementById('vvModalVerifyCodeUpdateSaveBtn'),
    resendBtn: document.getElementById('vvModalVerifyCodeResendBtn'),
    codeInput: document.getElementById('verificationcode'),
    codeInputFeedback: document.getElementById('vvModalVerifyCodeFeedback'),
    responseToken: "",
    rememberChk: document.getElementById('totp_remember_email'),
    form: document.getElementById('vvModalVerifyCodeForm'),
    emailService: {},
    verifyCodeService: {}
  }
*/

  const fieldFormMap = {
    'code': '#' + emailConfig.codeInput.id,
  }
  ///////////////////////////


  function doVerify() {
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/mfa/totp/email/send`, 
      { 
        "send": true,
      }, "POST");
  }

  const { interpret } = window.XState;      
   emailConfig.emailService = interpret(
    simpleInvokeMachine.withConfig({
      actions : {
        actionFailed: (context, event) => {
          
          if (context.error && (context.error.code==='request_invalid' || context.error.code==='request_rate_limit')) {
            let retrySeconds = "10";
            if (context.error.response && context.error.response.retry_after_seconds && !Number.isNaN(parseInt(context.error.response.retry_after_seconds, 10))) {
              retrySeconds = context.error.response.retry_after_seconds;
            }
            vv_utils.showStateErrors(`The email send request can not be processed so soon, please wait ${retrySeconds} seconds and try again.`, {}, emailConfig.formAlertbox);
          } else {
            vv_utils.logError(context.error);
            vv_utils.showStateErrors("There was an unexpected error", context.error , emailConfig.formAlertbox);
          }
        },
        actionSucceeded: (context, event)=> {
          
          emailConfig.verifyTitle.innerText = "Please check your inbox for the verification code";
          let jsonResponse = context.data;
          if (jsonResponse.token) {
            emailConfig.responseToken = jsonResponse.token;
          }
          vv_utils.clearalert(emailConfig.formAlertbox);

          if (jsonResponse.redirect) {
            vv_utils.showalert("Account verification succeeded, now redirecting you to our home application.", "primary", emailConfig.formAlertbox);
            setTimeout( () => {window.location.assign(jsonResponse.redirect)} , 3000);
          }
          emailConfig.emailService.send("IDLE");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) =>  {return doVerify(context, event)}
      }
    })
  )
  .onTransition((state)=> {})
  .start();

  emailConfig.emailService.send("FETCH");

  emailConfig.resendBtn.addEventListener('click', (e) => {
    e.preventDefault();
    emailConfig.verifyTitle.innerText = "Re-sending now...";
    emailConfig.emailService.send("FETCH");
  })


  //Modal VerificationCode Update
  const vvModalVerifyCodeForm = emailConfig.form;
  const vvModalVerifyCodeFeedback = emailConfig.codeInputFeedback;
  const vvModalVerifyCodeUpdateSaveBtn = emailConfig.verifyBtn;

  const verificationcodeFieldFormMap = fieldFormMap;
  
  function checkVerificationCodeValidity() {
    return new Promise((resolve, reject) => {
      
      let vvModalVerifyCodeText = emailConfig.codeInput;
      let valid = true;

      //should be a 6 digit string
      //eslint-disable-next-line
      vvModalVerifyCodeText.value = vvModalVerifyCodeText.value.replace(/[^\d]+/g, '');
      if (vvModalVerifyCodeText.value && vvModalVerifyCodeText.value.length === 6 && /^\d+$/.test(vvModalVerifyCodeText.value)) {
        //
      } else {
        valid = false;
        vv_utils.makeInvalid(vvModalVerifyCodeText);
      }

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function updateVerificationCode(context, event) {
    
    //in the future pass the verificationcode value through state machine 
    let verificationcode = emailConfig.codeInput.value;
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/auth/mfa/totp/email/verify`, 
      { 
        "code": verificationcode,
        "token": emailConfig.responseToken ? emailConfig.responseToken : "",
        "remember_device": emailConfig.rememberChk.checked,
      }, "POST");
  }

  emailConfig.verifyCodeService = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
        },
        message: (context, event) => {
          //
          vv_utils.clearInputValidation(vvModalVerifyCodeForm);
          vv_utils.clearalert(emailConfig.formAlertbox);

        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", emailConfig.formAlertbox);
        },
        validationSucceeded: () => {
          emailConfig.verifyCodeService.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {
          if (context.error && context.error.fields) {  
            vv_utils.highlightFields(context.error.fields, verificationcodeFieldFormMap);
          }
          if (context.error) {  
            
            vv_utils.logError(context.error);
            
            if (context.error.code === 'totp_failure') {
              vv_utils.showStateErrors("Incorrect TOTP code", {}, emailConfig.formAlertbox);
            } else {
              vv_utils.showStateErrors("There was an unexpected error", context.error, emailConfig.formAlertbox);
            }
          }
        },
        actionSucceeded: (context, event) => {
          
          if (context.data.redirect) {
            window.location.assign(context.data.redirect);
            return;
          }          
          vv_utils.showalert("Updated successfully.", "primary", emailConfig.formAlertbox);
          //add a tiny delay to allow clears before modal showing
          setTimeout(function () {
            emailConfig.verifyCodeService.send("LOAD_COMPLETE");
          }, 2000);
        }
      },
      services: {
        //eslint-disable-next-line
        validate_service: (context, event) => checkVerificationCodeValidity(context, event),
        action_service: (context, event) => updateVerificationCode(context, event)
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  //eslint-disable-next-line
  vv_utils.AttachAndSendFormEventsToMachineService(vvModalVerifyCodeForm, emailConfig.verifyCodeService, 'input', 'input');
  //eslint-disable-next-line
  vv_utils.addFormAndMachineServiceChangeAndInputHandlers(vvModalVerifyCodeForm, emailConfig.verifyCodeService, (e)=>{if (e.preventDefault) e.preventDefault()});
  vv_utils.AttachAndSendFormEventsToMachineService(vvModalVerifyCodeForm, emailConfig.verifyCodeService, 'input[type="checkbox"]', 'change');

  emailConfig.verifyCodeService.send("LOAD_COMPLETE");

  vvModalVerifyCodeUpdateSaveBtn.addEventListener('click', (e) => {
    e.preventDefault();
    emailConfig.verifyCodeService.send("SUBMIT");
  })

  ///////////////////////////

}